module.exports = {
      id: "video-usage",
      viewBox: "0 0 84 64",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#video",
      toString: function () {
        return this.url;
      }
    }